<div class="main-loading-container" [style]="setStyle()" [@fadeOut]="isVisible ? 'visible' : 'invisible'">
    <div class="back-cover" [style]="setBack(this.sliders[4])"></div>
    <div class="back-cover" [@fadeOut]="progress < 80 ? 'visible' : 'invisible'" [style]="setBack(this.sliders[3])"></div>
    <div class="back-cover" [@fadeOut]="progress < 60 ? 'visible' : 'invisible'" [style]="setBack(this.sliders[2])"></div>
    <div class="back-cover" [@fadeOut]="progress < 40 ? 'visible' : 'invisible'" [style]="setBack(this.sliders[1])"></div>
    <div class="back-cover" [@fadeOut]="progress < 20 ? 'visible' : 'invisible'" [style]="setBack(this.sliders[0])"></div>
     <div *ngIf="isLoading" class="values">
         {{ progress }}
     </div>
    <div *ngIf="isLoading" class="loader" [ngStyle]="{'clip-path': clipPath}">
        <app-icon [icon]="Icons.mainLoading"/>
    </div>
    <div *ngIf="!isLoading" class="title-page-container">
        <div class="title-page-center-el">
            <div class="title-page-title ">
                <div class="title-page-icon">
<!--                    <app-icon [icon]="Icons.mother"/>-->
                </div>
                Карта памятных мест
            </div>
            <div class="title-page-subtitle">
                <div>
                    Проект Северной железной дороги – филиала ОАО «РЖД»,
                </div>
                <div>
                    призванный увековечить память о подвиге железнодорожников
                </div>
                <div>
                    в годы Великой Отечественной войны.
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isLoading" class="title-page-title-mob">
        <div class="title-mob-container">
            <div class="col-4">
                <div class="title-page-title-mob-icon">
<!--                    <app-icon [icon]="Icons.mother"/>-->
                </div>
            </div>
            <div class="col-8">
                <div class="title-page-mob-title">Карта памятных мест</div>
                <div class="title-page-mob-subtitle">
                    Проект Северной железной дороги – филиала ОАО «РЖД»,
                    призванный увековечить память о подвиге железнодорожников
                    в годы Великой Отечественной войны.
                </div>
            </div>
        </div>
    </div>
</div>
